const map = document.querySelector('.interactive-map__map');
const mapInfo = document.querySelector('.interactive-map__info');
const mapInfoContent = document.querySelector('.interactive-map__info .sk-container');
let mapLocations;

const fetchFieldsToModal = () => {
  fetch(`${themeVars.home}/wp-json/wp/v2/location/?per_page=100`, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
    .then(async response => {
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      return response.json();
    })
    .then(data => {
      if (data.length > 0) mapLocations = data;
    })
    .catch((error) => console.log(error))
    .finally(() => {});
}

const openModal = () => {
  if (!map) return;
  fetchFieldsToModal();

  const handleLocationClickOrEnter = (e) => {
    const targetLocation = e.target;
    const acrivePath = map.querySelector('path.active');

    const hideInfo = () => {
      acrivePath?.classList.remove('active');
      mapInfo.classList.remove('open');
      setTimeout(() => mapInfoContent.innerHTML = '', 500);
    }

    if (targetLocation.classList.contains('location')) {
      const locationId = targetLocation.getAttribute('id')?.toLowerCase().replace(/\s/g, '-');

      if (targetLocation !== acrivePath) {
        acrivePath?.classList.remove('active');
        targetLocation?.classList.add('active');
        const activeLocation = mapLocations?.find((location) => location.acf.location_flag.toLowerCase().replace(/\s/g, '-') === locationId);
        let contentData = activeLocation && activeLocation?.acf.location_title ? `<div class="interactive-map__info-hero"><h2 class="interactive-map__info-title" data-aos="fade-up" data-aos-delay="150">${activeLocation.acf.location_title}</h2>` : '';
        contentData += (activeLocation && activeLocation?.acf.location_flag) ? `<div class="interactive-map__info-flag" data-aos="fade-up"><svg width="40" height="50" data-svg="icon-${activeLocation.acf.location_flag}-flag"><use href="#icon-${activeLocation.acf.location_flag}-flag"></use></svg></div></div>` : '';
        contentData += activeLocation && activeLocation?.acf.location_content ? `<div class="interactive-map__info-content" data-aos="fade-up" data-aos-delay="250">${activeLocation.acf.location_content}</div>` : '';
        if (contentData) mapInfoContent.innerHTML = contentData;
        contentData && !mapInfo?.classList.contains('open') && mapInfo.classList.add('open');
      } else {
        mapInfo?.classList.contains('open') && hideInfo();
      }
    } else {
      mapInfo?.classList.contains('open') && hideInfo();
    }
  }

  map.addEventListener('click', handleLocationClickOrEnter);

  map.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const targetLocation = document.activeElement;
      if (targetLocation.classList.contains('location')) {
        handleLocationClickOrEnter(e);
      }

      setTimeout(() => {
        const infoSection = document.querySelector('.interactive-map__info');
        if (infoSection) {
          infoSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  });
}

window.addEventListener('load', () => openModal());
